import {
	checkParams,
	zeroUnit,
	soFarDate,
	getCheckboxSheetValue,
	getCondition,
} from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'
import { hasValue } from '../../utils/order'

function getSelfDiseaseValue(diseaseMap, diseaseList, desc) {
	if (!(diseaseList && diseaseList.length)) {
		return ''
	}
	let diseaseStr = getCheckboxSheetValue(
		diseaseMap,
		diseaseList.filter(disease => disease !== '09')
	)
	if (diseaseList.includes('09') && hasValue(desc)) {
		return `${diseaseStr}${hasValue(diseaseStr) ? '、' : ''}${desc}`
	} else {
		return diseaseStr
	}
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const injuredInfo = (injured && injured.injuredInfo) || {}
	let arr = []

	arr = arr.concat([
		{
			label: '实际就诊医院',
			value: injuredInfo.factVisitingHospital,
		},
		{
			label: '实际就诊科室',
			value: injuredInfo.factVisitingDepartment,
		},
	])
	let isPAIC = this.isPAIC && this.isFirstVisit
	if (isPAIC || (!this.isPAIC && (this.isFirstVisit || this.isResurvey))) {
		arr.push({
			label: '住院号',
			value: injuredInfo.inpatientNo,
		})
	}
	arr.push({ label: '床位号', value: injuredInfo.bedNo })
	if (isPAIC) {
		arr.push(
			{
				label: '首次治疗时间',
				value:
					injuredInfo.firstTreatmentTime &&
					formatDatetime(injuredInfo.firstTreatmentTime),
			},
			{
				label: '治疗情况',
				value: getCondition(
					setting,
					[injuredInfo.condition, injuredInfo.conditionDetail],
					''
				),
			},
			{
				label: '伤者主诉',
				value: injuredInfo.injuredStatement,
			}
		)
	} else {
		arr.push(
			{
				label: '治疗情况',
				value: setting.treatmentMap[injuredInfo.treatment],
			},
			{
				label: '送诊方式',
				value: setting.referralWaysMap[injuredInfo.referralWays],
			},
			{
				label: '精神状况',
				value: setting.mentalStatusMap[injuredInfo.mentalStatus],
			}
			// {
			// 	label: '治疗方式',
			// 	value: setting.treatWaysMap[injuredInfo.treatWays],
			// 	key: 'treatWays',
			// }
		)
	}

	if (!this.isPAIC && (!this.isFirstVisit || this.isCarInsurance)) {
		arr = arr.concat([
			{
				label: '自主吃饭',
				value: setting.independentMap[injuredInfo.selfFeeding],
				key: 'selfFeeding',
			},
			{
				label: '自主翻身',
				value: setting.independentMap[injuredInfo.selfTurning],
				key: 'selfTurning',
			},
			{
				label: '自主大、小便',
				value: setting.independentMap[injuredInfo.selfUrinating],
				key: 'selfUrinating',
			},
			{
				label: '自主穿衣',
				value: setting.independentMap[injuredInfo.selfDressing],
				key: 'selfDressing',
			},
			{
				label: '自主洗漱',
				value: setting.independentMap[injuredInfo.selfWashing],
				key: 'selfWashing',
			},
		])
	}

	if (
		(this.isFirstVisit || this.isResurveyInHospital) &&
		this.isHealthInsurance
	) {
		arr.push({
			label: '伤者以前是否有自身疾病',
			value:
				injuredInfo.selfDiseaseFlag === '1'
					? getSelfDiseaseValue(
							setting.selfDiseaseMap,
							injuredInfo.selfDisease,
							injuredInfo.selfDiseaseDesc
					  )
					: setting.haveNoneMap[injuredInfo.selfDiseaseFlag],
		})
	}

	arr.push({
		label: '入院日期',
		value: formatDate(injuredInfo.hospitalizedDate),
	})

	if (!this.isFirstVisit || this.isPAIC) {
		arr.push({
			label: isPAIC
				? '出院日期（未出院填写预估出院时间）'
				: '出院日期（未出院无需填写）',
			value: soFarDate(injuredInfo.leaveDate),
		})
	}
	arr = arr.concat([
		{
			label:
				(this.isFirstVisit || this.isResurvey) &&
				!this.isCarInsurance &&
				!this.isPAIC
					? '已产生的医药费'
					: '已花费',
			value: zeroUnit(injuredInfo.alreadySpent, '元'),
		},
		{
			label: '还需花费（预估）',
			value: zeroUnit(injuredInfo.remainSpent, '元'),
		},
	])

	if (!isPAIC) {
		arr.push({
			label: '诊断名称',
			value: injuredInfo.diagnoseName,
		})
	}

	if (!isPAIC && this.$auth('dataPermission:diagnosis')) {
		let diagnoseList = injuredInfo.diagnoseList || []
		let diagnoseName = ''
		const keyArr = ['primarySite', 'secondSite', 'thirdSite', 'forthSite']
		diagnoseList = diagnoseList.filter(item => {
			return hasValue(item['primarySite']) && hasValue(item['secondSite'])
		})
		for (const [index, item] of diagnoseList.entries()) {
			let str = ''
			let resArr = []
			for (const key of keyArr) {
				if (hasValue(item[key])) {
					resArr.push(item[key])
				}
			}
			str = resArr.join('-')
			diagnoseName += `${index > 0 ? ' ' : ''}${index + 1}、${str}`
		}
		arr.push({
			label: this.isPAIC ? '三期诊断库' : '诊断库',
			value: diagnoseName,
		})
	}

	if (!isPAIC) {
		arr.push({
			label: '现阶段诊疗方案',
			value: injuredInfo.operationName,
		})
	}
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		const awayInHospital = injuredInfo.awayInHospital
		arr.push({
			label: '是否每日在医院治疗',
			value: setting.independentMap[awayInHospital],
		})
		if (awayInHospital === '1') {
			arr.push({
				label: '每日在医院治疗时长',
				value: zeroUnit(injuredInfo.inHospitalHours, '小时'),
			})
		}
	}
	if (isPAIC) {
		arr.push({
			label: '是否需要垫付医疗费用',
			value: setting.yesNoMap[injuredInfo.advancePay],
		})
	}
	if (!isPAIC) {
		arr.push({
			label: '治疗方式',
			value: setting.treatWaysMap[injuredInfo.treatWays],
		})
		if (this.isFirstVisit) {
			arr.push({
				label: '主治医师的初步诊断意见',
				value: injuredInfo.initialDiagnosis,
			})
		}
	}
	const obj = {
		title: '伤者伤情信息',
		children: arr,
	}
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		if (injuredInfo.treatWays === '01') {
			obj.show = {
				surgery: true,
			}
		}
	}
	if (isPAIC && this.$auth('dataPermission:diagnosis')) {
		if (!obj.show) {
			obj.show = {}
		}
		obj.show.diagnoseTable = true
	}

	return obj
}
